import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IFrameCommunicationService } from 'ZalamoLibrary/src/lib/core/iframe-communication/iframe-communication.service';

@Component({
    selector: 'app-iframe-bridge',
    templateUrl: './iframe-bridge.component.html',
    styleUrls: ['./iframe-bridge.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IframeBridgeComponent implements OnInit {
  constructor(private iFrameCommunicationService: IFrameCommunicationService) {}

  ngOnInit(): void {}
}
